// ============================================================
// LexNova — English (EN) translations
// ============================================================
const en = {
  // ── Navigation ──────────────────────────────────────────
  nav: {
    inicio:       'Home',
    queGanas:     'What You Gain?',
    comoFunciona: 'How It Works?',
    planes:       'Plans',
    misionVision: 'Mission & Vision',
    contacto:     'Contact',
    empezar:      'Get Started',
  },

  // ── Home page ────────────────────────────────────────────
  home: {
    hero: {
      headline1: 'We automate your processes and centralize your messages',
      highlight: 'so your business responds and operates faster',
      headline2: ', without complications.',
      subtext:   'With personalized solutions, you turn repetitive tasks into efficiency and more sales.',
      cta:       'Schedule a demo',
    },
    futuro: {
      title: 'The future of your operation',
    },
    features: [
      {
        id:          'automatizacion',
        title:       'Automation',
        description: 'Eliminate operational bottlenecks by connecting your key tools. Let intelligent workflows handle the routine while you focus on growing.',
      },
      {
        id:          'agentes',
        title:       'AI Agents',
        description: 'Deploy virtual assistants that understand your business context. Immediate, accurate, and personalized responses 24/7 for your clients and team.',
      },
      {
        id:          'centralizacion',
        title:       'Message Centralization',
        description: 'Unify WhatsApp, emails, social media, and internal chat in a single omnichannel dashboard. Never lose track of an important conversation again.',
      },
    ],
  },

  // ── What You Gain? ───────────────────────────────────────
  queGanas: {
  hero: {
    title: 'Boost your business with',
    highlight: 'LexNova',
    subtext:
      'Discover the advantages of integrating artificial intelligence and automation into your daily operations.',
  },
  cards: [
    {
      id: 'automatizar',
      title: 'Automate',
      description:
        'Repetitive processes and tasks, reducing operating time and errors in your business.',
    },
    {
      id: 'ia',
      title: 'Artificial Intelligence',
      description:
        'Virtual assistants with natural, human-like conversations that improve your customer experience 24/7.',
    },
    {
      id: 'centralizar',
      title: 'Centralize',
      description:
        'WhatsApp, Facebook, and Instagram integrated into a single unified control panel.',
    },
    {
      id: 'integrar',
      title: 'Integrate',
      description:
        'Calendars and task managers with automated workflows synchronized in real time.',
    },
    {
      id: 'desarrollar',
      title: 'Develop',
      description:
        'High-performance websites and landing pages to strengthen your digital presence and conversions.',
    },
  ],
},

  // ── How It Works? ────────────────────────────────────────
  comoFunciona: {
    hero: {
      tag:       'System Architecture',
      title1:    'The anatomy of an',
      highlight: 'AI Agent',
      subtext:   'Discover the process behind intelligent automation. From the initial analysis to seamless integration with your current systems.',
    },
    metodologia: {
      title:   'Implementation Methodology',
      subtext: 'A structured process to guarantee tangible results and frictionless integration.',
    },
    steps: [
      {
        id:          '01',
        title:       'Business Diagnosis',
        description: 'We analyze your current workflows and identify ideal bottlenecks to automate.',
      },
      {
        id:          '02',
        title:       'Automated Flow Design',
        description: 'We map the conversational logic and integrations needed for an efficient agent.',
      },
      {
        id:          '03',
        title:       'AI Agent Implementation',
        description: 'We develop, train, and connect the model to your platforms (WhatsApp, Web, CRM).',
      },
      {
        id:          '04',
        title:       'Continuous Optimization',
        description: 'We monitor performance, adjust prompts, and expand capabilities based on real usage.',
      },
    ],
    capacidades: {
      title:   'System Capabilities',
      subtext: 'Interactions designed to convert and retain.',
    },
    caps: [
      {
        id:          'welcome',
        tag:         'Reception',
        title:       'Welcome Messages',
        description: 'Instant and contextual responses that initiate the commercial relationship immediately.',
        preview:     'Hi! 🤖 I\'m Nova, the virtual assistant. How can I help you with your business today?',
        previewReply:'I want info about plans.',
      },
      {
        id:          'horario',
        tag:         '24/7',
        title:       'After-Hours Assistance',
        description: 'Your business never sleeps. Capture leads and resolve queries at any hour.',
        preview:     'Are you open?',
        previewReply:'Our office is currently closed, but I can take your details and an advisor will contact you first thing tomorrow morning. 🌙',
      },
      {
        id:          'seguimiento',
        tag:         'Proactive',
        title:       'Automatic Follow-up',
        description: 'Re-engage cold prospects or confirm appointments without human intervention.',
      },
      {
        id:          'calificacion',
        tag:         'Feedback',
        title:       'Conversation Rating',
        description: 'Measure customer satisfaction instantly to improve the model.',
        preview:     'How would you rate our agent\'s service?',
      },
    ],
  },

  // ── Plans ────────────────────────────────────────────────
planes: {
  title: 'Plans designed for every stage',
  subtext:
    'Choose the automation level that best fits your current operation. Start simple and scale when your business is ready.',
  popular: 'MOST POPULAR',
  cta: 'Book a demo',

  pricing: {
    proPromoPrice: '$13,499',
    proRegularPrice: '$17,500 + VAT/month',
    proPromoPeriod: '+ VAT/month for the first 3 months',
    enterprisePriceLabel: 'Custom',
    enterprisePeriod: 'Custom quote',
  },

  cardLabels: {
    selected: 'Selected',
    seeMore: 'Select to see more',
    visible: 'Information visible',
    contactSales: 'Contact sales',
    proPromoNote: 'Promotion: pay the Lex Essential price for the first 3 months.',
  },

  plans: [
    {
      id: 'personal',
      name: 'Lex Personal',
      tagline: 'Your first intelligent assistant to automate without complexity.',
      price: '$9,500',
      period: '+ VAT/month',
      popular: false,
      features: [
        'Conversational agent on WhatsApp',
        'AI trained with your FAQs',
        'Google Calendar for appointments',
        'Basic reminders',
        'Simple webhooks',
        'Initial operational follow-up',
      ],
    },
    {
      id: 'essential',
      name: 'Lex Essential',
      tagline: 'Commercial automation to capture and qualify opportunities.',
      price: '$13,499',
      period: '+ VAT/month',
      popular: false,
      features: [
        '1 channel: WhatsApp, Instagram, or Facebook',
        'AI for replies and qualification',
        'Basic CRM panel',
        'Centralized Chatwoot inbox',
        'Airtable or Google Sheets',
        'Meta Forms and CSV/XLSX export',
      ],
    },
    {
      id: 'pro',
      name: 'Lex Pro',
      tagline: 'Advanced automation for teams that need to scale.',
      price: '$17,500',
      period: '+ VAT/month',
      popular: true,
      features: [
        'Essential price for 3 months',
        'Advanced omnichannel operation',
        'Custom commercial workflows',
        'Premium integrations',
        'Reports and analytics',
        'Automation between stages',
      ],
    },
    {
      id: 'enterprise',
      name: 'Lex Enterprise',
      tagline: 'Tailored solutions for corporate operations.',
      price: 'Custom',
      period: 'Custom quote',
      popular: false,
      features: [
        'Custom AI development',
        'Enterprise integrations',
        'Dedicated support',
        'Operation-based SLA',
        'Custom infrastructure',
        'Corporate scalability',
      ],
    },
  ],

  supplements: {
    personal: {
      eyebrow: 'Entry point',
      title: 'Automate operational tasks without complex systems',
      description:
        'Ideal for entrepreneurs, independent professionals, and businesses with low to medium message volume that want to save time without implementing complex tools.',
      details: [
        'Automatically replies from one WhatsApp number.',
        'Helps with appointments, reminders, and basic follow-up.',
        'Does not include CRM, sales funnels, or advanced reports.',
      ],
    },
    essential: {
      eyebrow: 'Start scaling',
      title: 'AI + CRM panel to filter prospects',
      description:
        'Designed for growing SMBs with active marketing and a small sales team that needs faster replies, lead qualification, and visibility across the commercial process.',
      details: [
        'Centralizes conversations and opportunities in one panel.',
        'Qualifies leads and exports data to Airtable, Sheets, or CSV/XLSX.',
        'Does not include advanced automation, remarketing, or detailed reports.',
      ],
    },
    pro: {
      eyebrow: 'Active promotion',
      title: 'Lex Pro at the Essential price for 3 months',
      description:
        'An option for businesses that already need more channels, stronger integrations, and deeper commercial automation from the start.',
      details: [
        'Promotional price of $13,499 + VAT/month for the first 3 months.',
        'After that, it continues at the regular price of $17,500 + VAT/month.',
        'Designed for teams that require more advanced workflows, reports, and integrations.',
      ],
    },
    enterprise: {
      eyebrow: 'Custom',
      title: 'Contact the sales department',
      description:
        'For corporate operations, technical scope, infrastructure, integrations, and support are defined after reviewing your processes.',
      details: [
        'Personalized technical and commercial diagnosis.',
        'Custom AI architecture for specific processes.',
        'Dedicated support, SLA, and custom infrastructure.',
      ],
    },
  },
},

  // ── Mission & Vision ─────────────────────────────────────
  misionVision: {
    hero: {
      title1:    'The Purpose of',
      highlight: 'LexNova',
      subtext:   'Designing the future of intelligent automation.',
    },
    mision: {
      label:       'Mission',
      description: 'Empower businesses to automate their processes and improve communication with their clients through intuitive and personalized AI solutions.',
    },
    vision: {
      label:       'Vision',
      description: 'Become the leading strategic partner for companies seeking to integrate artificial intelligence into their DNA, making automation a standard, accessible, and fundamental tool for digital growth.',
    },
  },

  // ── Contact ──────────────────────────────────────────────
  contacto: {
    hero: {
      title1:    'Let\'s talk about the',
      highlight: 'future',
      subtext:   'We\'re here to resolve your doubts and help you take the next step in the evolution of your business.',
    },
    info: {
      slogan: 'Automate today. Scale tomorrow.',
      email:  'hola@lexnova.cloud',
      phone:  '+54 9 11 1234-5678',
    },
    form: {
      nombre:    'Full name',
      empresa:   'Company',
      correo:    'Email address',
      whatsapp:  'WhatsApp number',
      mensaje:   'Message',
      placeholders: {
        nombre:   'e.g. John Smith',
        empresa:  'Your company',
        correo:   'john@company.com',
        whatsapp: '+1 9...',
        mensaje:  'How can we help you?',
      },
      submit:    'Send Message',
      success:   'Message sent! We\'ll be in touch soon.',
    },
  },

  // ── Footer ───────────────────────────────────────────────
  footer: {
    copyright: '© 2024 LexNova. Automate today. Scale tomorrow.',
    links: {
      whatsapp:  'WhatsApp',
      instagram: 'Instagram',
      facebook:  'Facebook',
      website:   'www.lexnova.cloud',
    },
  },
} as const;

export default en;
